import React, { useEffect, useState, useRef } from "react";
import { CiCircleMinus } from "react-icons/ci";
import { CiCirclePlus } from "react-icons/ci";
import axios from "axios";
import "react-toastify/dist/ReactToastify.css";
import './alert.css'
import { useNavigate } from "react-router-dom";
export default function Bettingbutton({
  setProfileData,
  setResultData,
  setActiveUserData,
  SetActivemultiplier,
  setroundStatusDummyActive
}) {
     const navigate = useNavigate();
  const role = localStorage.getItem("role");
  const [activestate, Setactivestate] = useState("Tab1");
  const [activestate1, Setactivestate1] = useState("Tab1");
  const [gameRoundId, setGameRoundId] = useState(null);
  const [multiplier, setMultiplier] = useState(null);
  const [roundStatus, setroundStatus] = useState(null);
  const [isGameActive, setIsGameActive] = useState(false);
  const [isGameActive2, setIsGameActive2] = useState(false);
  const [autovalue, setautovalue] = useState(1.1);
  const [betId, setbetId] = useState(null);
  const [finalMultiplier, setFinalMultiplier] = useState(null);
  const [delay, setDelay] = useState(null);
  const userId = localStorage.getItem("_id");
  const [getAutoData, setAutoData] = useState([]);
  const [alerts, setAlerts] = useState([]);
  const alertStyles = {
    primary: 'alert-primary',
    success: 'alert-success',
    danger: 'alert-danger',
    warning: 'alert-warning',
    info: 'alert-info',
    light: 'alert-light',
  };

  const addAlert = (type, message) => {
    const id = Date.now(); 
 
    setAlerts((prevAlerts) => {
      const existingAlert = prevAlerts.find(alert => alert.type === type);
      if (existingAlert) {
        return prevAlerts; 
      }
      return [...prevAlerts, { id, type, message }];
    });
    setTimeout(() => handleClose(id), 1000); 
  };
  

  const handleClose = (id) => {
    setAlerts((prevAlerts) => prevAlerts.filter((alert) => alert.id !== id));
  };
  const [ActiveData, setActiveData] = useState();
  const [inrvalueTab1, setInrvalueTab1] = useState(0);
  const [inrvalueTab2, setInrvalueTab2] = useState(0);
  useEffect(() => {
    profileDataLoad();
    resultDataLoad();
  }, []);
  useEffect(() => {
    let hasCalledStatus = false;
    let hasCalledStatusplacebet = false;
    let hasCalledStatusCash = false;

    const ws = new WebSocket("https://avitorsocket.a2logicgroup.com/");
    // const ws = new WebSocket("http://localhost:5000");

    ws.onopen = () => console.log("Connected to WebSocket");
    ws.onmessage = (event) => {
      const data = JSON.parse(event.data);

      const handleGameStarting = () => {
        setDelay(data.delay);
        let roundsta = data.roundStatus;
        setroundStatus(roundsta);
        setroundStatusDummyActive(roundsta);
    
        setGameRoundId(data.roundId);
        localStorage.setItem("roundId",data.roundId)
        if (!hasCalledStatusplacebet && getAutoData.autoBetCount > 0) {
          ActiveUsersDataLoad();
          hasCalledStatusplacebet = true;
        }
      };

      const handleMultiplierUpdate = () => {
        setMultiplier(data.multiplier);
        SetActivemultiplier(data.multiplier);
        if (
          !hasCalledStatusCash &&
          data.multiplier &&
          getAutoData.autoBetCount > 0
        ) {
         
          hasCalledStatusCash = true;
        }

        if (data.multiplier && !hasCalledStatus) {
        
          setroundStatusDummyActive(data.roundStatus);
          setroundStatus(data.roundStatus);
           ActiveUsersDataLoad()
          hasCalledStatus = true;
        }
      };

      const handleGameCrash = () => {
        setFinalMultiplier(data.finalMultiplier);
        setroundStatus(data.roundStatus);
    
        setIsGameActive(false);
        setIsGameActive2(false);
        hasCalledStatusplacebet = false;
        hasCalledStatusCash = false;
        resultDataLoad();
        ActiveUsersDataLoad();
        setroundStatusDummyActive(null);
        if (data.finalMultiplier) {
          setTimeout(() => {
            SetActivemultiplier(null);
            setFinalMultiplier("");
          }, 5000);
        }
        hasCalledStatus = false;
      };

      switch (data.type) {
        case "gameStarting":
          handleGameStarting();
          break;
        case "multiplierUpdate":
          handleMultiplierUpdate();
          break;
        case "gameCrash":
          handleGameCrash();
          break;
        default:
          console.log("Unknown event type:", data.type);
      }
    };

    ws.onclose = () => console.log("Disconnected from WebSocket");
    ws.onerror = (error) => console.error("WebSocket error:", error);

    return () => ws.close();
  }, []);
  const hadleclickbutton = (Tab) => {
    Setactivestate(Tab);
  };
  const hadleclickbutton1 = (Tab) => {
    Setactivestate1(Tab);
  };

  const decrementTab1 = () => {
    if (inrvalueTab1 > 0) {
      setInrvalueTab1(inrvalueTab1 - 10);
    } else {
      alert("min 1 Indian Rupee You Can Bet");
    }
  };
  const decrementTab2 = () => {
    if (inrvalueTab2 > 0) {
      setInrvalueTab2(inrvalueTab2 - 10);
    } else {
      alert("min 1 Indian Rupee You Can Bet");
    }
  };
  const incrementTab1 = () => {
    if (inrvalueTab1 < 1000) {
      setInrvalueTab1(inrvalueTab1 + 10);
    } else {
      addAlert('danger', 'Max 1000 Rupee You Can Bet');
    }
  };
  const incrementTab2 = () => {
    if (inrvalueTab2 < 1000) {
      setInrvalueTab2(inrvalueTab2 + 10);
    } else {
      addAlert('danger', 'Max 1000 Rupee You Can Bet');
    }
  };
  const valueupdateTab1 = (value) => {
    setInrvalueTab1(value);
  };
  const valueupdateTab2 = (value) => {
    setInrvalueTab2(value);
  };

  const [isChecked, setIsChecked] = React.useState(false);
  const handleToggle = () => {
    setIsChecked((prevChecked) => !prevChecked);
  };
  const profileDataLoad = async () => {
    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("_id");
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/profile/getUserProfile`,
        {
          userId: userId,
          role: role,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
         
        }
      );
      console.warn(response.data.user.Wallet_balance);
      setProfileData(response.data.user.Wallet_balance); // Update profile data in parent component
    } catch (err) {
      console.error("Error fetching profile data:", err);
    }
  };
  const resultDataLoad = async () => {
    const token = localStorage.getItem("token");
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/bets/ResultList`,{

          userId: userId,
          role: role,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`, // Include token in headers if needed
          },
        }
      );
      console.warn("dd",response)
      setResultData(response.data.results.reverse()); // Store results in reversed order
    } catch (err) {
      console.warn("ss",err)
      if(err && err.status == 401){
        console.warn("hh",err.status)
        navigate("/");
        localStorage.clear();
      }
      console.error("Error fetching data:", err);
    }
  };
  const resultDataLoadStatus = async () => {
    const token = localStorage.getItem("token");

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/bets/checkGameStatus`,{
          userId: userId,
          role: role,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`, // Include token in headers if needed
          },
        
        }
      );
      // setroundStatus(response.data.roundStatus); // Store results in reversed order
    } catch (err) {
      console.error("Error fetching data:", err);
    }
  };

  const placeBet = async () => {
    if (!gameRoundId) {
      addAlert('danger', 'WAITING FOR NEXT ROUND');
      return;
    }
    let betAmount;
    if (inrvalueTab1) {
      betAmount = parseFloat(inrvalueTab1);
    } else if (inrvalueTab2) {
      betAmount = parseFloat(inrvalueTab2);
    } else {
      console.error("Invalid bet amount or tab state");
     
      return; // Exit if there's no valid bet amount
    }
    const token = localStorage.getItem("token");
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/api/bets/placeBet`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          userId: userId,
          role: role,
          gameRoundId: gameRoundId,
          betAmount: parseFloat(betAmount),
          betType: "normal",
        }),
      }
    );
    resultDataLoadStatus();
    ActiveDataLoad();

    if (response.status === 201) {
      setIsGameActive(true);
      await profileDataLoad(); 
      await resultDataLoad();
      await ActiveUsersDataLoad();
    
      const data = await response.json();
      addAlert('success', 'Bet Ok!');
    } else if (response.status === 203) {
      console.error("Error placing bet");
      addAlert('danger', 'Insufficient funds');
    } else {
      console.error("Error placing bet");
      addAlert('danger', 'WAITING FOR NEXT ROUND');
    }

  };
  const placeBet2 = async () => {
    if (!gameRoundId) {
      addAlert('danger', 'WAITING FOR NEXT ROUND');

      return;
    }
    let betAmount;
    if (inrvalueTab2) {
      betAmount = parseFloat(inrvalueTab2);
    } else if (inrvalueTab1) {
      betAmount = parseFloat(inrvalueTab1);
    } else {
      console.error("Invalid bet amount or tab state");
      return; // Exit if there's no valid bet amount
    }
    const token = localStorage.getItem("token");
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/api/bets/placeBet`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          userId: userId,
          role: role,
          gameRoundId: gameRoundId,
          betAmount: parseFloat(betAmount),
        }),
      }
    );
    resultDataLoadStatus();
    ActiveDataLoad();

    if (response.status === 201) {
      setIsGameActive2(true);
      await profileDataLoad(); // Call profileDataLoad after placing a bet
      await resultDataLoad();
      await ActiveUsersDataLoad();

      const data = await response.json();

      addAlert('success', 'Bet Ok!');

    } else if (response.status === 203) {
      console.error("Error placing bet");
      addAlert('danger', 'Insufficient funds');
    } else {
      console.error("Error placing bet");
      addAlert('danger', 'WAITING FOR NEXT ROUND');

    }
  };
  const cancelBet = async () => {
    const token = localStorage.getItem("token");
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/api/bets/cancelBet`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          userId: userId,
          role: role,
          betId: betId,
          // betAmount: parseFloat(inrvalue)
        }),
      }
    );
    resultDataLoadStatus();
    setIsGameActive(false);
    if (response.ok) {
      await profileDataLoad(); // Call profileDataLoad after placing a bet
      await resultDataLoad();
      await ActiveUsersDataLoad();
      const data = await response.json();
      addAlert('success', 'canceled!');
    
    } else {
      console.error("Error placing bet");
      addAlert('danger', 'Cancel!');
   
    }
  };
  const cancelBet2 = async () => {
    // if (!gameRoundId) {

    //     setNextRound("Waiting for next round");
    //     return;
    // }

    const token = localStorage.getItem("token");
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/api/bets/cancelBet`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          userId: userId,
          role: role,
          betId: betId,
          // betAmount: parseFloat(inrvalue)
        }),
      }
    );
    resultDataLoadStatus();
    setIsGameActive2(false);
    if (response.ok) {
      await profileDataLoad(); // Call profileDataLoad after placing a bet
      await resultDataLoad();
      await ActiveUsersDataLoad();
      const data = await response.json();
 
      addAlert('success', 'canceled!');
    
    } else {
      console.error("Error placing bet");
      addAlert('danger', 'Cancel!')
    }
  };
  const cashOut = async () => {
  
    const token = localStorage.getItem("token");
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/api/bets/cashOut`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          userId: userId,
          role: role,
          gameRoundId: gameRoundId,
          currentMultiplier: multiplier,
        }),
      }
    );

    setIsGameActive(false);
    if (response.ok) {
      await profileDataLoad(); 
      await resultDataLoad();
      await ActiveUsersDataLoad()
      const data = await response.json();
      addAlert('light', `Cashed Out! ₹${data.winnings.toFixed(2)}`);
    
    } else {
      console.error("Error cashing out");
      addAlert('danger', `You lost`);

    }
  };
  const cashOut2 = async () => {
 
    const token = localStorage.getItem("token");
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/api/bets/cashOut`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          userId: userId,
          role: role,
          gameRoundId: gameRoundId,
          currentMultiplier: multiplier,
        }),
      }
    );

    setIsGameActive2(false);
    if (response.ok) {
      await profileDataLoad(); 
      await resultDataLoad();
      await ActiveUsersDataLoad()
      const data = await response.json();

      addAlert('light', `Cashed Out! ₹${data.winnings.toFixed(2)}`);
    
    } else {
      console.error("Error cashing out");
      addAlert('danger', `You lost`);

    }
  };
  const handleChangeTab1 = (e) => {
    const value = e.target.value;

    // Allow empty input or numeric input between 1 and 100
    if (value === "" || (value >= 1 && value <= 1000)) {
      setInrvalueTab1(value);
    } else {
      alert("Please enter a number between 1 and 1000");
    }
  };

  const handleChangeTab2 = (e) => {
    const value = e.target.value;
    if (value === "" || (value >= 1 && value <= 1000)) {
      setInrvalueTab2(value);
    } else {
      alert("Please enter a number between 1 and 1000");
    }
  };
  useEffect(() => {
    ActiveDataLoad();
  }, []);
  const ActiveDataLoad = async () => {
    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("_id");
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/bets/getActiveUsers`,
        {
          userId: userId,
          role: role,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
         
        }
      );
      setActiveData(response.data.activeUsers);
      setbetId(response.data.activeUsers[0].betId);
    } catch (err) {
      console.error("Error fetching profile data:", err);
    }
  };

  const [isPopupVisible, setPopupVisible] = useState(false);

  const openPopup = () => {
    if (inrvalueTab1 > 0) {
      setPopupVisible(true);
    } else {
      alert("The value is not greater than 0");
    }
  };
  const ActiveUsersDataLoad = async () => {
    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("_id");
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/bets/getActiveUsers`,
        {
          userId: userId,
          role: role,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        
        }
      );
      setActiveUserData(response.data.activeUsers);
    } catch (err) {
      console.error("Error fetching profile data:", err);
    }
  };
 
  return (
    <>
    <div className="alertmessage">
    {alerts[0] && (
  <div key={alerts[0].id} className={`alert ${alertStyles[alerts[0].type] || 'alert-primary'}`}>
    <span>{alerts[0].message}</span>
    <button className="closealert" onClick={() => handleClose(alerts[0].id)}>x</button>
  </div>
)}

    </div>
  
    <div>
        
      <div className="d-flex justify-content-between gap-1" id="bettingbutton">
        <div className="bettingone">
          <div className="d-flex justify-content-center">
            <div className="tabs_button">
              <div
                className={activestate === "Tab1" ? "Tab1 tab  Active" : "Tab1"}
                onClick={() => hadleclickbutton("Tab1")}
              >
                Bet
              </div>
           
            </div>
          </div>
          <div className="tabcontnet">
            {activestate === "Tab1" && (
              <div className="d-flex align-items-center">
                <div className="w-100">
                  <div className="d-flex bgcolorblack">
                    <div className="decrement" onClick={decrementTab1}>
                      <CiCircleMinus className="text-white" />
                    </div>
                    <div className="amtountinr d-flex justify-content-center">
                      <input
                        type="text"
                        value={inrvalueTab1 > 0 ? inrvalueTab1 : ""}
                        // onChange={(e) => setInrvalue(e.target.value)}
                        onChange={handleChangeTab1}
                        className="inputinr"
                      />
                    </div>
                    <div className="increment" onClick={incrementTab1}>
                      <CiCirclePlus className="text-white" />
                    </div>
                  </div>
                  <div className="d-flex ratebutton">
                    <button onClick={() => valueupdateTab1(1)}>1.0</button>
                    <button onClick={() => valueupdateTab1(2)}>2.0</button>
                    <button onClick={() => valueupdateTab1(5)}>5.0</button>
                    <button onClick={() => valueupdateTab1(10)}>10.0</button>
                  </div>
                </div>
                {(roundStatus !== "active" ||
                  roundStatus === null ||
                  roundStatus !== "start") &&
                  !isGameActive && (
                    <div
                    className="placebet bettingbuttondesign"
                    onClick={placeBet}
                  >
                    <h3 className="bettingbutton">BET</h3>
                    <h2 className="bettingbutton">{inrvalueTab1} INR</h2>
                  </div>
                  )}
                {isGameActive &&
                  roundStatus === "start" &&
                  ActiveData.some((user) => user.userId === userId) && (
                    <div className="CashOut bg-warning" onClick={cashOut}>
                      <h3 className="bettingbutton">CASH OUT</h3>
                      <h2 className="bettingbutton">
                        {(inrvalueTab1 * multiplier).toFixed(2)} INR
                      </h2>
                    </div>
                  )}
                {isGameActive &&
                  roundStatus === "active" &&
                  ActiveData.some((user) => user.userId === userId) && (
                    <div
                      className="placebet cancelbutton bg-danger"
                      onClick={cancelBet}
                    >
                      <h3 className="bettingbutton">CANCEL</h3>
                    </div>
                  )}
              </div>
            )}

          </div>
        </div>
        <div className="bettingtwo">
          <div className="d-flex justify-content-center">
            <div className="tabs_button">
              <div
                className={
                  activestate1 === "Tab1" ? "Tab1 tab  Active" : "Tab1"
                }
                onClick={() => hadleclickbutton1("Tab1")}
              >
                Bet
              </div>
            </div>
          </div>
          <div className="tabcontnet">
            {activestate1 === "Tab1" && (
              <div className="d-flex align-items-center">
                <div className="w-100">
                  <div className="d-flex bgcolorblack">
                    <div className="decrement" onClick={decrementTab2}>
                      <CiCircleMinus className="text-white" />{" "}
                    </div>
                    <div className="amtountinr d-flex justify-content-center">
                      <input
                        type="text"
                        value={inrvalueTab2 > 0 ? inrvalueTab2 : ""}
                        onChange={handleChangeTab2}
                        className="inputinr"
                      />
                    </div>
                    <div className="increment" onClick={incrementTab2}>
                      <CiCirclePlus className="text-white" />
                    </div>
                  </div>
                  <div className="d-flex ratebutton">
                    <button onClick={() => valueupdateTab2(1)}>1.0</button>
                    <button onClick={() => valueupdateTab2(2)}>2.0</button>
                    <button onClick={() => valueupdateTab2(5)}>5.0</button>
                    <button onClick={() => valueupdateTab2(10)}>10.0</button>
                  </div>
                </div>
                {(roundStatus !== "active" ||
                  roundStatus === null ||
                  roundStatus !== "start") &&
                  !isGameActive2 && (
                    <div
                      className="placebet bettingbuttondesign"
                      onClick={placeBet2}
                    >
                      <h3 className="bettingbutton">BET</h3>
                      <h2 className="bettingbutton">{inrvalueTab2} INR</h2>
                    </div>
                  )}
                {isGameActive2 &&
                  roundStatus === "start" &&
                  ActiveData.some((user) => user.userId === userId) && (
                    <div className="CashOut bg-warning" onClick={cashOut2}>
                      <h3 className="bettingbutton">CASH OUT</h3>
                      <h2 className="bettingbutton">
                        {(inrvalueTab2 * multiplier).toFixed(2)} INR
                      </h2>
                    </div>
                  )}
                {isGameActive2 &&
                  roundStatus === "active" &&
                  ActiveData.some((user) => user.userId === userId) && (
                    <div
                      className="placebet cancelbutton bg-danger"
                      onClick={cancelBet2}
                    >
                      <h3 className="bettingbutton">CANCEL</h3>
                    </div>
                  )}
              </div>
            )}          
          </div>
        </div>
      </div>
          </div>
    </>
    
  );
}
